import { Slider as AntdSlider } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { SliderSingleProps } from 'antd';

export const Slider = createGuardedComponent(AntdSlider);
